<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        sm="12"
        md="7"
        lg="7"
      >
        <div
          v-if="loadingGrafico"
          id="carregaDados"
          class="text-center"
          :style="styleObject"
        >
          <v-icon
            light
            class="custom-loader"
            :style="styleObject"
          >
            mdi-cached
          </v-icon>
          Carregando Dados...
        </div>
        <div
          v-else-if="errorGrafico"
          class="alert alert-danger"
        >
          {{ errorGrafico }}
        </div>
        <div>
          <h3
            v-if="exbirTextoGrafico"
            id="tituloEntregas"
            class="text-center"
          >
            Entregas
          </h3><br>
          <v-row>
            <v-col
              cols="12"
              sm="6"
              md="6"
              lg="6"
            >
              <canvas
                id="chartRankingEntrega"
                class="text-center"
                width="70"
                height="50"
              />
            </v-col>
            <v-col
              cols="6"
              sm="6"
              md="6"
              lg="6"
            >
              <v-row
                v-for="(lista, grupo) in statusAgrupados"
                :key="grupo"
              >
                <h4>{{ grupo }}</h4>

                <v-col
                  v-for="status in lista"
                  :key="status.status"
                  cols="12"
                  class="d-flex align-center"
                >
                  <v-icon :color="status.cor">
                    {{ status.icone }}
                  </v-icon>

                  <span class="font-weight-light text-caption">
                    {{ status.status }} - Total de Notas {{ status.total }}
                  </span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="5"
        lg="5"
      >
        <div
          v-if="loadingTable"
          id="carregaDados"
          class="text-center"
          :style="styleObject"
        >
          <v-icon
            light
            class="custom-loader"
            :style="styleObject"
          >
            mdi-cached
          </v-icon>
          Carregando Dados...
        </div>
        <div
          v-else-if="errorTable"
          class="alert alert-danger"
        >
          {{ errorTable }}
        </div>
        <div v-if="temRanking">
          <h3 class="text-center">
            Entregas por Motorista
          </h3>
          <br><br>
          <v-select
            id="dadoMovimentacao"
            v-model="selectMotositas"
            :items="motoristas"
            item-value="id"
            item-text="motorista"
            label="Selecione o Motorista"
            return-object
            clearable
            @change="filtrarMotoristas()"
          />
          <div
            id="idTable"
            style="overflow-x: auto"
          >
            <table
              style="width: 100%; color: black; border-collapse: collapse"
              class="elevation-1"
              mobile-breakpoint="0"
            >
              <thead>
                <tr>
                  <th
                    id="dadoMovimentacaoHeader"
                    style="text-align: center"
                    class="black--text title"
                  >
                    Motorista
                  </th>
                  <th
                    id="dadoMovimentacaoHeader"
                    style="text-align: center"
                    class="black--text title"
                  >
                    Notas
                  </th>
                  <th
                    id="dadoMovimentacaoHeader"
                    style="text-align: center"
                    class="black--text title"
                  >
                    Total
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in (tableRankingEntregaFiltrada.length > 0 ? tableRankingEntregaFiltrada : tableRankingEntrega)"
                  :key="item.id"
                >
                  <td
                    id="dadoMovimentacao"
                    style="text-align: left; width: 40%;"
                  >
                    {{ item.motorista }}
                  </td>
                  <td style="width: 40%;">
                    <div class="segmented-progress">
                      <v-progress-linear
                        :model-value="100"
                        height="25"
                        rounded
                        :style="{ background: buildGradient(item) }"
                      />

                      <div class="segmented-progress__labels">
                        <div
                          v-for="(status, i) in item.status"
                          :key="i"
                          class="segmented-progress__label"
                          :style="segmentLabelStyle(status, item.totalEntrega)"
                        >
                          {{ status.valor }}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td
                    id="dadoMovimentacao"
                    style="text-align: right; width: 20%;"
                  >
                    {{ item.totalEntrega }}
                  </td>
                </tr>
              </tbody>
            </table><br>
            <v-row
              align="center"
              class="ma-0"
              style="margin: -1.5rem 0px 0px !important"
            >
              <v-col
                cols="12"
                sm="5"
                md="5"
                lg="5"
              >
                <h5>Total de Motoristas {{ totalMotoristas }}</h5>
              </v-col>
              <v-col
                cols="12"
                sm="7"
                md="7"
                lg="7"
              >
                <v-row
                  align="center"
                  class="ma-0"
                >
                  <div
                    v-for="(legendaItem, i) in (legendaFilter.length > 0 ? legendaFilter : legenda)"
                    id="dadoMovimentacao"
                    :key="i"
                  >
                    <v-avatar
                      class="mr-1"
                      :color="legendaItem.cor"
                      size="10"
                    />
                    <span class="mr-3 font-weight-light">{{ legendaItem.status }}</span>
                  </div>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </div>
</template>

<script>
  import Entrega from '../../../../services/entrega'
  import eventEmit from '../../components/core/EventoEmit'
  import Chart from 'chart.js'

  export default {
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
    },
    data () {
      return {
        styleObject: {
          color: localStorage.corPrimaria,
        },
        primeiroDia: '',
        dataFinal: '',
        dataInicialStatus: '',
        dataFinalStatus: '',
        select: [],
        motorista: [],
        tableRankingEntrega: [],
        tableRankingEntregaFiltrada: [],
        dadosGrafico: {},
        coresAPI: [],
        coresEntrega: [],
        loadingTable: false,
        errorTable: null,
        loadingGrafico: false,
        errorGrafico: null,
        idEntrega: null,
        statusEntrega: [],
        enableGrafico: false,
        dadosAberto: [],
        dadosConcluida: [],
        totalNotas: 0,
        exbirTextoGrafico: false,
        exibirTabela: false,
        totalMotoristas: 0,
        motoristas: [],
        selectMotositas: [],
        selectStatusEntrega: [],
        legenda: [],
        legendaFilter: [],
        snackbar: {
          visible: false,
          color: 'success',
          direction: 'top center',
          message: 'My timeout is set to 3000.',
          timeout: 3000,
        },
      }
    },

    computed: {
      statusAgrupados () {
        return this.dadosConcluida.reduce((acc, item) => {
          if (!acc[item.status]) {
            acc[item.status] = []
          }

          acc[item.status].push(item)

          return acc
        }, {})
      },
      temRanking () {
        return (
          !this.loadingTable &&
          !this.errorTable &&
          this.tableRankingEntrega &&
          this.tableRankingEntrega.length > 0
        )
      },
    },

    created () {
      eventEmit.$on('update-form-magis-entrega', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-form-magis-entrega', this.handleUpdateDados)
    },

    mounted () {},

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, dataInicialStatus, dataFinalStatus, motorista, status) {
        this.primeiroDia = primeiroDia
        this.dataFinal = dataFinal
        this.dataInicialStatus = dataInicialStatus
        this.dataFinalStatus = dataFinalStatus
        this.motorista = motorista
        this.selectStatusEntrega = status

        this.atualizaTable()
      },

      async atualizaTable () {
        this.loadingTable = true
        this.loadingGrafico = true
        this.errorGrafico = false
        this.errorTable = false
        this.tableRankingEntrega = []
        this.tableRankingEntregaFiltrada = []
        this.totalNotas = 0
        this.exbirTextoGrafico = false
        this.dadosAberto = []
        this.dadosConcluida = []
        this.exibirTabela = false
        this.totalMotoristas = 0
        this.motoristas = []
        this.selectMotositas = []
        this.legenda = []
        this.legendaFilter = []

        if (this.dadosGrafico.data) {
          this.dadosGrafico.destroy()
        }

        await Entrega.showDadosGraficoEntrega(this.primeiroDia, this.dataFinal, this.select, localStorage.tokencontrato, this.dataInicialStatus, this.dataFinalStatus, this.motorista, this.selectStatusEntrega).then((resposta) => {
          if (resposta.data.status) {
            this.totalNotas = resposta.data.totalNotas

            const ctx = document.getElementById('chartRankingEntrega').getContext('2d')

            Chart.plugins.register({
              beforeDraw: function (chart) {
                if (chart.config.options.elements.center) {
                  var ctx = chart.chart.ctx
                  var centerConfig = chart.config.options.elements.center
                  var fontStyle = centerConfig.fontStyle || 'Arial'
                  var txt = centerConfig.text
                  var color = centerConfig.color || '#000'
                  var sidePadding = centerConfig.sidePadding || 20
                  var sidePaddingCalculated = (sidePadding / 100) * (chart.innerRadius * 2)

                  // Ajuste do tamanho da fonte
                  ctx.font = '40px ' + fontStyle
                  var stringWidth = ctx.measureText(txt).width
                  var elementWidth = (chart.innerRadius * 2) - sidePaddingCalculated
                  var widthRatio = elementWidth / stringWidth
                  var newFontSize = Math.floor(30 * widthRatio)
                  var elementHeight = (chart.innerRadius * 2)

                  if (newFontSize > elementHeight) {
                    newFontSize = elementHeight
                  }

                  ctx.textAlign = 'center'
                  ctx.textBaseline = 'middle'
                  ctx.font = newFontSize + 'px ' + fontStyle
                  ctx.fillStyle = color

                  var centerX = ((chart.chartArea.left + chart.chartArea.right) / 2)
                  var centerY = ((chart.chartArea.top + chart.chartArea.bottom) / 2)
                  ctx.fillText(txt, centerX, centerY)
                }
              },
            })

            this.dadosGrafico = new Chart(ctx, {
              type: 'doughnut',
              data: {
                labels: resposta.data.label,
                datasets: [
                  {
                    label: 'Total Notas Entregues',
                    data: resposta.data.dados,
                    backgroundColor: resposta.data.cores,
                  },
                ],
              },
              options: {
                legend: {
                  display: false,
                },
                responsive: true,
                cutoutPercentage: 70,
                tooltips: {
                  enabled: true,
                },
                elements: {
                  center: {
                    text: this.totalNotas.toString(),
                    color: '#000',
                    fontStyle: 'Arial',
                    sidePadding: 20,
                  },
                },
              },
            })

            this.dadosConcluida = resposta.data.dadosStatus.map((item, i) => {
              var listaConcluida = {
                cor: item.cor,
                status: item.status,
                total: item.total,
                icone: item.icone,
              }

              return listaConcluida
            })
          }
        }).catch((e) => {
          if (e.message === 'Network Error') {
            this.errorGrafico = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else {
            this.error = e.data.msg
            this.showSnackbar('error', 3000, e.data.msg)
          }
        }).finally((f) => {
          this.loadingGrafico = false

          this.exbirTextoGrafico = true
        })

        await Entrega.showDadosMotoristas(this.primeiroDia, this.dataFinal, this.select, localStorage.tokencontrato, this.dataInicialStatus, this.dataFinalStatus, this.motorista, this.selectStatusEntrega).then((resposta) => {
          if (resposta.data.status) {
            this.totalMotoristas = resposta.data.totalMotoristas

            this.motoristas = resposta.data.motoristas

            this.tableRankingEntrega = resposta.data.dados.map((item, i) => {
              var listaLegenda = {
                id: item.id,
                motorista: item.motorista,
                totalEntrega: item.totalEntrega,
                status: item.status,
              }

              return listaLegenda
            })

            var count = 1

            this.legenda = resposta.data.legenda.map((item, i) => {
              var legenda = {
                id: count++,
                cor: item.cor,
                status: item.status,
              }

              return legenda
            })
          }
        }).catch((e) => {
          if (e.message === 'Network Error') {
            this.errorTable = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else {
            this.error = e.data.msg
            this.showSnackbar('error', 3000, e.data.msg)
          }
        }).finally((f) => {
          this.loadingTable = false

          this.exibirTabela = true
        })
      },

      filtrarMotoristas () {
        if (!this.selectMotositas) {
          this.tableRankingEntregaFiltrada = []
          this.legendaFilter = []
          return
        }

        this.legendaFilter = []

        const motorista = this.tableRankingEntrega.filter(m => m.motorista === this.selectMotositas.motorista)

        this.tableRankingEntregaFiltrada = motorista

        motorista.forEach(m => {
          m.status.forEach(st => {
            this.legendaFilter.push(st)
          })
        })
      },

      buildGradient (item) {
        const total = item.totalEntrega || 1
        let acumulado = 0

        const segmentos = item.status
          .filter(s => s.valor > 0)
          .map(s => {
            const perc = (s.valor / total) * 100
            const start = acumulado
            const end = Math.min(acumulado + perc, 100)
            acumulado = end

            const cor = s.cor

            return `${cor} ${start}% ${end}%`
          })

        return `linear-gradient(to right, ${segmentos.join(', ')})`
      },

      segmentLabelStyle (status, total) {
        const p = total ? (status.valor / total) * 100 : 0

        return {
          width: `${p}%`,
          backgroundColor: status.cor,
          color: '#fff',
          textAlign: 'center',
          fontSize: '12px',
          fontWeight: 500,
        }
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
  @media screen and (min-device-width: 320px) and (max-device-width: 680px) {
    #idTable {
      max-height: 500px;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }

    #legendaId {
      margin: 0rem 0 0 0;
    }
  }

  @media screen and (min-width: 680px) and (max-width: 960px) and (-webkit-min-device-pixel-ratio: 1) {
  }

  @media screen and (min-width: 1380px) and (max-width: 1800px) {
    #dadoMovimentacao {
      font-size: 10px !important;
    }

    #tituloEntregas {
      margin: 0 0 0 -5rem;
    }
  }

  @media screen
  and (min-width: 1801px) {
    #dadoMovimentacao {
      font-size: 12px !important;
    }

    #tituloEntregas {
      margin: 0 0 0 -7rem;
    }
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 600px;
  }

  #dadoMovimentacao {
    font-size: 9.5px;
  }

  #tituloEntregas {
    margin: 0 0 0 -4rem;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  #legendaId {
    margin: 5rem 0 0 0;
  }

  .segmented-progress {
    position: relative;
    width: 100%;
  }

  /* Força o gradiente no preenchimento do v-progress-linear */
  .segmented-progress__bar :deep(.v-progress-linear__background) {
    opacity: 0; /* some o fundo padrão */
  }
  .segmented-progress__bar :deep(.v-progress-linear__determinate) {
    width: 100% !important;              /* barra cheia (model-value = 100) */
    background: var(--seg-gradient) !important; /* aplica o gradiente */
    border-radius: inherit;
  }

  /* Camada dos labels exatamente por cima da barra */
  .segmented-progress__labels {
    position: absolute;
    inset: 0;
    display: flex;
    pointer-events: none; /* não intercepta cliques/hover */
    border-radius: inherit;
  }

  /* Cada label ocupa a largura do respectivo segmento */
  .segmented-progress__label {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 6px;
    color: #fff;
    font-size: 12px;
    line-height: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: clip;
    text-shadow: 0 1px 2px rgba(0,0,0,.6); /* melhora contraste */
  }
</style>
